export const MEDIA_URL = "https://backend.lifeskillglobal.online";